import React, { useCallback } from 'react';
import { Platform } from 'react-native';

import { openUrl } from '../../utils';
import { TextLink } from '../TextLink';

import type { PhoneLinkProps } from './types';

export const PhoneLink = ({
  phoneNumber,
  protocol,
  alertLabel = 'Something went wrong, try again later.',
  ...rest
}: PhoneLinkProps) => {
  const url = `${protocol}:${phoneNumber}`;

  const handlePress = useCallback(async () => {
    await openUrl(url, alertLabel);
  }, [url, alertLabel]);

  // Web exposes a real `tel:`/`sms:` anchor so right-click, copy, and screen
  // readers see the phone number; native uses `onPress` to keep the `canOpenURL` +
  // `Alert` fallback (passing `href` on native would route through `WebBrowser`).
  if (Platform.OS === 'web') {
    return <TextLink href={url} {...rest} />;
  }

  return <TextLink onPress={handlePress} {...rest} />;
};
